import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router"
import { Router } from "@angular/router"
import { UserService } from "../services/user.service"
import { redirectToError } from "../utils/error-handling"
import { Location } from "@angular/common"

@Injectable()
export class TeacherAuthGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private router: Router,
        private location: Location
    ) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.userService.isLoggedIn()) {
            redirectToError(this.router, this.location, "401")
            return false
        }
        if (this.userService.isStudent()) {
            redirectToError(this.router, this.location, "403")
            return false
        }
        return true
    }
}
